/**
 * Created by johanm on 16/10/15.
 *
 * Cut overflowing text on word boundary and replace by ellipsis (…)
 */
define('all/jquery/jquery.ellipsis',['jquery'], function ($) {
	'use strict';
	/**
	 * Cut off text on word boundary to fit containing element. Containing
	 * element must only contain plain text (text node) and must also have
	 * its height limited by height, max-height or containing element.
	 *
	 * @param {boolean} elIsMultiline - Indicates wether element is multline or not. The classname "ellipsis-multiline" is used as fallback for non-boolean values.
	 * @returns {*}
	 */
	$.fn.ellipsis = function(elIsMultiline) {
		function isHeightOverflowing(el, copy) { return copy.height() > el.height();}
		function isWidthOverflowing(el, copy)  { return copy.width() > el.width(); }

		return this.each(function() {
			var el = $(this),
				text = el.text(),
				originalLength = text.length,
				t = $(this.cloneNode(true)),
				multiline,
				isOverflowing,
				lastSpace;

			if (elIsMultiline === true || elIsMultiline === false) {
				multiline = elIsMultiline;
			} else {
				multiline = el.hasClass('ellipsis-multiline');
			}
			isOverflowing = multiline ? isHeightOverflowing : isWidthOverflowing;

			t.hide()
				.css('position', 'absolute')
				.css('overflow', 'visible')
				.css('width', multiline ? el.width() : 'auto')
				.css('height', multiline ? 'auto' : el.height())
				.css('maxHeight', 'none');
			el.after(t);

			while (text.length > 0 && isOverflowing(el, t)) {
				lastSpace = text.lastIndexOf(' ');
				text = text.substr(0, lastSpace);
				t.html(text + '&hellip;');
			}

			if (text.length < originalLength) {
				el.html(text + '&hellip;');
			}
			t.remove();
		});
	};
});

